import { Empty } from '~/src/styles/shared-css/empty-text-error';

const getEmptyOutputComponentArray = (emptyText: string) => {
    return [<Empty key={emptyText}>{emptyText}</Empty>];
};

export const getEmptyOutputData = (emptyText: string) => {
    return [{
        id: emptyText,
        value: '',
        isEmpty: true,
        isDefaultCursor: true,
        Component: getEmptyOutputComponentArray(emptyText),
    }];
};